import React, { CSSProperties, useMemo } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { FilterDescriptor } from '@progress/kendo-data-query'

interface FilterValue {
  id: string | number
  label: string | number | null
  value: string | number
}

interface SelectFilterProps {
  placeholder?: string
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  data: FilterValue[]
  style?: CSSProperties
}

export const SelectFilter: React.FC<SelectFilterProps> = ({
  placeholder,
  filter,
  onFilterChange,
  data,
  style,
}) => {
  const items = useMemo(
    () =>
      data.map((item) => ({
        value: String(item.value),
        label: item.label ?? item.id,
      })),
    [data]
  )

  const valueMap = useMemo(() => {
    return new Map(data.map((item) => [String(item.value), item.value]))
  }, [data])

  const selectedValue = filter.value == null ? '' : String(filter.value)

  return (
    <div style={{ width: 250, ...style }}>
      <Select
        items={items}
        value={selectedValue || undefined}
        onValueChange={(value) => {
          if (value == null) {
            onFilterChange.call(undefined, {
              nextFilter: {
                ...filter,
                value: null,
              },
            })
            return
          }

          const originalValue = valueMap.get(value)

          onFilterChange.call(undefined, {
            nextFilter: {
              ...filter,
              value: originalValue ?? null,
            },
          })
        }}
      >
        <SelectTrigger className='w-full'>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        <SelectContent>
          {data.map((item) => (
            <SelectItem key={item.id} value={String(item.value)}>
              {item.label ?? item.id}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
